import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import {
  IAccountDrawResponse,
  ICategoryPricingDetailsResponse,
  IDropDrawResponse,
  IUpdateCategoryDrawRequest,
  IUpdateDropDrawRequest,
} from "@miplatform/types";

export const useCustomerDrawsDistributionTabViewModel = () => {
  const [defaultDraws, setDefaultDraws] = useState<IAccountDrawResponse[]>([]);
  const [categories, setCategories] = useState<
    ICategoryPricingDetailsResponse[]
  >([]);
  const [dropDraws, setDropDraws] = useState<IDropDrawResponse[]>([]);

  const stateManager = useComponentState();

  const getDefaultDraws = async (accountId: string) => {
    return stateManager.run(async () => {
      const response = await homeService.draws.getAll({
        accountId,
        sort: "displayOrder asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setDefaultDraws(response.data);
      }
      return response;
    });
  };

  const getCategories = async (accountId: string) => {
    return stateManager.run(async () => {
      const response = await homeService.accountPricing.getAll({
        accountId,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setCategories(response.data);
      }
      return response;
    });
  };

  const getDropDraws = async (accountId: string) => {
    return stateManager.run(async () => {
      const response = await homeService.accountPricing.dropDraws.getAll({
        accountId,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setDropDraws(response.data);
      }
      return response;
    });
  };

  const updateCategoryDraws = async (
    accountId: string,
    data: IUpdateCategoryDrawRequest[]
  ) => {
    return stateManager.run(async () => {
      const response = await homeService.accountPricing.updateAll({
        accountId,
        data,
        toastMessageConfig: {
          success: {
            text: "Category draw distributions updated successfully.",
          },
        },
      });
      return response;
    });
  };

  const updateDropDraws = async (
    accountId: string,
    data: IUpdateDropDrawRequest[]
  ) => {
    return stateManager.run(async () => {
      const response = await homeService.accountPricing.dropDraws.updateAll({
        accountId,
        data,
        toastMessageConfig: {
          success: { text: "Drop draw distributions updated successfully." },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setDropDraws(response.data);
      }
      return response;
    });
  };

  return {
    defaultDraws,
    categories,
    dropDraws,
    getDefaultDraws,
    getCategories,
    getDropDraws,
    updateCategoryDraws,
    updateDropDraws,
    isLoading: stateManager.isBusy(),
  };
};
